export default __webpack_public_path__ + "static/media/mail.08cceefe.svg";